import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/lib/i18n";

const BG = "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxtZXRhbCUyMHdvcmtlciUyMHdlbGRpbmd8ZW58MHx8fHwxNzg0NTAwNTQ4fDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`ABRAMS OS — ${u.name}`);
      const next = sp.get("next");
      navigate(next || (u.role === "operator" ? "/operator" : "/dashboard"));
    } catch (err) {
      toast.error(err.response?.data?.detail || t("invalid_credentials"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-white">
      <div className="hidden md:block md:w-1/2 relative" style={{ background: "#12233f" }}>
        <img src={BG} alt="ABRAMS" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(18,35,63,0.55), rgba(18,35,63,0.92))" }} />
        <div className="relative z-10 h-full flex flex-col justify-between p-12">
          <img src="/abrams-logo-white.png" alt="ABRAMS" className="h-10 w-auto self-start" />
          <div>
            <h1 className="font-display font-700 text-5xl leading-[0.95] text-white tracking-tight">
              Un ecosistema.<br />Ogni reparto.<br /><span style={{ color: "#7fa3e8" }}>Tempo reale.</span>
            </h1>
            <p className="text-[#c3d3ef] mt-4 max-w-md">
              Produzione, commesse, consegne e collaboratori — impianti per il settore oleario, digitalizzati.
            </p>
          </div>
        </div>
      </div>

      <div className="w-full md:w-1/2 flex items-center justify-center p-6 relative" style={{ background: "var(--bg)" }}>
        <div className="w-full max-w-sm animate-rise">
          <img src="/abrams-logo.png" alt="ABRAMS" className="md:hidden h-9 w-auto mb-8" />
          <h2 className="font-display font-700 text-3xl t-head tracking-tight">{t("login_title")}</h2>
          <p className="t-muted mt-1 mb-8">{t("login_sub")}</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="lbl">{t("email")}</label>
              <input data-testid="login-email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="field mt-1.5 py-3" />
            </div>
            <div>
              <label className="lbl">{t("password")}</label>
              <input data-testid="login-password" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)} className="field mt-1.5 py-3" />
            </div>
            <button data-testid="login-submit" disabled={loading}
              className="btn-primary btn-industrial w-full flex items-center justify-center gap-2 font-500 py-3 rounded-[3px] disabled:opacity-60">
              <LogIn size={18} /> {loading ? t("signing") : t("signin")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
